module.exports = __webpack_public_path__ + "static/media/storyblok.979fb127.svg";